import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5178bd78")

_pushScopeId("data-v-5178bd78")
const _hoisted_1 = { class: "ui__banner_container" }
const _hoisted_2 = { class: "swiper-container" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "toc_ui__banner_leftBottom" }
const _hoisted_5 = { class: "toc_ui__banner_leftBottom_text" }
const _hoisted_6 = {
  key: 0,
  class: "toc_ui__banner_center"
}
const _hoisted_7 = { class: "toc_ui__banner_carName" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "(车型仅供参考，实际车型请以实车为准）", -1)
const _hoisted_9 = {
  key: 0,
  class: "ui__banner_chekuangwxts"
}
const _hoisted_10 = { class: "ui__banner_chekuangwxts_main" }
const _hoisted_11 = /*#__PURE__*/_createVNode("b", null, "温馨提示：本报告检测内容仅供参考，不可直接作为车辆交易凭证。", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 如您参考此报告购车，268V不承担任何检测失误责任。")
const _hoisted_13 = {
  key: 1,
  class: "ui__banner_chekuangTip"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: {"ui-chekuang": _ctx.state.reportMsg.RpCK()}
  }, [
    _createVNode("div", {
      class: ["ui__banner_box", {'xnyBG': _ctx.state.isXNY}]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.imgList, (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "swiper-slide",
                key: item.photoIdStr
              }, [
                _createVNode("img", {
                  src: item.smallPhotoUrl ? _ctx.urlConversion(item.smallPhotoUrl) : _ctx.urlConversion(item.photoPath)
                }, null, 8, ["src"])
              ]))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.state.slideIndex+1) + " / " + _toDisplayString(_ctx.state.showLen), 1)
        ]),
        (_ctx.state.defectLength>0)
          ? (_openBlock(), _createBlock("ul", _hoisted_6, [
              _createVNode("li", {
                class: {'toc_ui__banner_center_active' : _ctx.state.isBase},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeGroup(0)))
              }, "外观", 2),
              _createVNode("li", {
                class: {'toc_ui__banner_center_active' : !_ctx.state.isBase},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeGroup(1)))
              }, "瑕疵", 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("h2", null, [
          _withDirectives(_createVNode("span", {
            class: ["carTypeSign", {'xny': _ctx.state.isXNY}]
          }, "新能源", 2), [
            [_vShow, _ctx.state.isXNY]
          ]),
          _createVNode("span", null, _toDisplayString(_ctx.state.modelName), 1)
        ]),
        _hoisted_8
      ])
    ], 2),
    (_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("img", {
              src: require('../../../assets/toc/tipIcon.png')
            }, null, 8, ["src"]),
            _hoisted_11,
            _hoisted_12
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_13, " 质量管理体系符合标准：GB/T 19001-2016/ISO 9001:2015 "))
      : _createCommentVNode("", true)
  ], 2))
})